import { transformObjectKeys } from "@core/utility/common-utils"
import { RecursiveSnakeCaseType, transformFromCamelCaseToSnakeCase, transformFromSnakeCaseToCamelCase } from "@core/utility/string-utils"
import { Observable, of, take } from "rxjs"

export let addCardToUserLoad = (uiBody:AddCardToUserUIRequestBody): Observable<AddCardToUserAPIRequestBody>=>{

  let apiBody = new AddCardToUserAPIRequestBody({data:transformObjectKeys(
    uiBody,
    transformFromCamelCaseToSnakeCase
  )})
  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let addCardToUserSuccess = (apiBody:AddCardToUserAPIResponseBody):AddCardToUserUIResponseBody=>{
  let uiBody = new AddCardToUserUIResponseBody(transformObjectKeys(
    apiBody.data,
    transformFromSnakeCaseToCamelCase
  ))
  return uiBody
}

export class AddCardToUserUIRequestBody {
  constructor(params:Partial<AddCardToUserUIRequestBody>={}){
    let origParams = Object.entries(params).filter(([key, val]) => {
      return !key.startsWith('param');
    });
    Object.assign(this, { ...Object.fromEntries(origParams) });
  }
  sessionId:string
  accessToken:string
}

export class AddCardToUserAPIRequestBody {
  constructor(params:Partial<AddCardToUserAPIRequestBody>={}){
    let origParams = Object.entries(params).filter(([key, val]) => {
      return !key.startsWith('param');
    });
    Object.assign(this, { ...Object.fromEntries(origParams) });
  }
  data:RecursiveSnakeCaseType<AddCardToUserUIRequestBody>
}

export class AddCardToUserUIResponseBody {
  constructor(params:Partial<AddCardToUserUIResponseBody>={}){
    let origParams = Object.entries(params).filter(([key, val]) => {
      return !key.startsWith('param');
    });
    Object.assign(this, { ...Object.fromEntries(origParams) });
  }

}

export class AddCardToUserAPIResponseBody {
  constructor(params:Partial<AddCardToUserAPIResponseBody>={}){
    let origParams = Object.entries(params).filter(([key, val]) => {
      return !key.startsWith('param');
    });
    Object.assign(this, { ...Object.fromEntries(origParams) });
  }
  data:RecursiveSnakeCaseType<AddCardToUserUIResponseBody>
}

